import { Container, Link, Text } from "@fluidattacks/design";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { styled, useTheme } from "styled-components";

const StyledList = styled.ul`
  list-style-type: disc;
  padding-left: 1.5rem;
  margin: 0;
`;

const AdvisoryUrls = ({
  urls,
}: Readonly<{ urls: string[] | null | undefined }>): React.JSX.Element => {
  const { t } = useTranslation();
  const theme = useTheme();

  if (_.isEmpty(urls) || _.isNil(urls)) {
    return (
      <Container>
        <Text
          color={theme.palette.gray[400]}
          fontStyle={"italic"}
          size={"md"}
          wordWrap={"normal"}
        >
          {t("searchFindings.tabVuln.notApplicable")}
        </Text>
      </Container>
    );
  }

  return (
    <StyledList>
      {urls.map(
        (url): JSX.Element => (
          <li key={url}>
            <Link
              color={theme.palette.gray[600]}
              href={url}
              iconPosition={"hidden"}
              target={"_blank"}
            >
              {url}
            </Link>
          </li>
        ),
      )}
    </StyledList>
  );
};

const formatAdvisoryUrls = (
  urls: string[] | null | undefined,
): React.JSX.Element => {
  return <AdvisoryUrls urls={urls} />;
};

export { formatAdvisoryUrls };
